import Vue from 'vue';
import kaporForm from './kapor-form/kapor-form.vue';
Vue.component('kapor-form', kaporForm);
